// extracted by mini-css-extract-plugin
export default {"carousel__wrapper":"ux","carousel__wrapper_on_sides":"vx","arrows_wrapper":"wx","arrows_wrapper_right":"xx","arrows_wrapper_vertical":"yx","arrows_wrapper_on_sides":"zx","arrow_button":"Ax","carousel_arrow_left":"Bx","carousel_arrow_left_on_side":"Cx","carousel_arrow_right_on_side":"Ex","carousel_arrow":"Fx","arrows_wrapper_rounded":"Gx","carousel__fullWidth":"Hx"};
    if(module.hot) {
      // 1714422955991
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  